import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
const COVER_IMAGE = 'https://cdn.magicpatterns.com/uploads/17oLybUbcnZotr5EWRmqrW/cover.png';
const BUYERS = [{
  name: 'Sarah M.',
  city: 'Austin',
  state: 'TX'
}, {
  name: 'Jennifer K.',
  city: 'Portland',
  state: 'OR'
}, {
  name: 'Michael R.',
  city: 'Boise',
  state: 'ID'
}, {
  name: 'Emily T.',
  city: 'Denver',
  state: 'CO'
}, {
  name: 'David L.',
  city: 'Charleston',
  state: 'SC'
}, {
  name: 'Amanda W.',
  city: 'Savannah',
  state: 'GA'
}, {
  name: 'Chris P.',
  city: 'Minneapolis',
  state: 'MN'
}, {
  name: 'Rachel H.',
  city: 'Asheville',
  state: 'NC'
}, {
  name: 'Brian S.',
  city: 'Tucson',
  state: 'AZ'
}, {
  name: 'Lauren D.',
  city: 'Nashville',
  state: 'TN'
}, {
  name: 'Kevin M.',
  city: 'Bend',
  state: 'OR'
}, {
  name: 'Jessica F.',
  city: 'Madison',
  state: 'WI'
}, {
  name: 'Andrew B.',
  city: 'Raleigh',
  state: 'NC'
}, {
  name: 'Megan C.',
  city: 'Salt Lake City',
  state: 'UT'
}, {
  name: 'Tyler J.',
  city: 'Chattanooga',
  state: 'TN'
}, {
  name: 'Stephanie N.',
  city: 'Flagstaff',
  state: 'AZ'
}, {
  name: 'Daniel G.',
  city: 'Burlington',
  state: 'VT'
}, {
  name: 'Nicole A.',
  city: 'Santa Fe',
  state: 'NM'
}, {
  name: 'Jason W.',
  city: 'Spokane',
  state: 'WA'
}, {
  name: 'Heather L.',
  city: 'Fort Collins',
  state: 'CO'
}, {
  name: 'Mark T.',
  city: 'Greenville',
  state: 'SC'
}, {
  name: 'Ashley R.',
  city: 'Ann Arbor',
  state: 'MI'
}, {
  name: 'Ryan K.',
  city: 'Bozeman',
  state: 'MT'
}, {
  name: 'Kimberly S.',
  city: 'Knoxville',
  state: 'TN'
}, {
  name: 'Josh P.',
  city: 'Wilmington',
  state: 'NC'
}, {
  name: 'Melissa H.',
  city: 'Eugene',
  state: 'OR'
}, {
  name: 'Eric D.',
  city: 'Sedona',
  state: 'AZ'
}, {
  name: 'Christina M.',
  city: 'Boulder',
  state: 'CO'
}, {
  name: 'Matt B.',
  city: 'Traverse City',
  state: 'MI'
}, {
  name: 'Lisa F.',
  city: 'Lexington',
  state: 'KY'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  useEffect(() => {
    const showNotification = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 6000);
    // Show notification every 10-12 seconds
    const interval = setInterval(() => {
      const randomDelay = Math.random() * 2000; // 0-2 seconds random variation
      setTimeout(showNotification, randomDelay);
    }, 10000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-231">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-50 max-w-[340px]" data-id="element-232">
          <div className="bg-white rounded-xl shadow-2xl border border-[#E8E2DB] p-3 flex gap-3" data-id="element-233">
            {/* Cover Image */}
            <div className="flex-shrink-0" data-id="element-234">
              <img src={COVER_IMAGE} alt="Audio Cover" className="w-16 h-16 rounded-lg object-cover shadow-sm" data-id="element-235" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-236">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-237">
                <BadgeCheck className="w-4 h-4 text-blue-500 flex-shrink-0" data-id="element-238" />
                <span className="text-xs font-medium text-blue-600" data-id="element-239">
                  Verified Purchase
                </span>
              </div>

              <p className="text-sm font-medium text-[#2D2A26] leading-tight" data-id="element-240">
                {currentBuyer.name} from {currentBuyer.city},{' '}
                {currentBuyer.state}
              </p>
              <p className="text-xs text-[#5D5852] mt-0.5" data-id="element-241">just purchased</p>
              <p className="text-[10px] font-medium text-[#C4856A] mt-1 leading-tight line-clamp-2" data-id="element-242">
                Your Dog Isn't Keeping You Awake, You Are: The Sleep Mirror
                Protocol Audio
              </p>
            </div>

            {/* Close Button */}
            <button onClick={() => setIsVisible(false)} className="flex-shrink-0 self-start text-[#8A8580] hover:text-[#2D2A26] transition-colors p-1" aria-label="Close notification" data-id="element-243">
              <X className="w-4 h-4" data-id="element-244" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}